import React, { useState } from 'react';
import { Menu, MenuItem, Tooltip, IconButton } from '@mui/material';
import TranslateIcon from '@material-ui/icons/Translate';
import { LANGUAGES_SUPPORTED } from '../../../../../../../utils/constants';

const LanguageSelector = ({
    availableLanguages = [],
    currentLanguage = 'en-US',
    onSelectLanguage,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    // Deduplicate available languages
    const uniqueLanguages = Array.from(new Set(availableLanguages));

    if (!uniqueLanguages || uniqueLanguages.length <= 1) {
        return null;
    }

    const handleOpenMenu = (e) => setAnchorEl(e.currentTarget);
    const handleCloseMenu = () => setAnchorEl(null);

    const currentLabel = LANGUAGES_SUPPORTED[currentLanguage] || currentLanguage.split('-')[0].toUpperCase();

    return (
        <>
            <Tooltip title={`Language: ${currentLabel}`} arrow>
                <IconButton
                    size="small"
                    aria-label="Select language"
                    onClick={handleOpenMenu}
                    style={{
                        color: Boolean(anchorEl) ? '#ED6628' : '#6b7280',
                        padding: 6,
                    }}
                >
                    <TranslateIcon style={{ fontSize: 20 }} />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        mt: 1,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                        minWidth: 150,
                    },
                }}
            >
                {uniqueLanguages.map((lang) => {
                    const isSelected = currentLanguage === lang;
                    const name = LANGUAGES_SUPPORTED[lang] || lang;
                    const code = lang.split('-')[0].toUpperCase();
                    return (
                        <MenuItem
                            key={lang}
                            selected={isSelected}
                            onClick={() => {
                                onSelectLanguage && onSelectLanguage(lang);
                                handleCloseMenu();
                            }}
                            sx={{
                                fontSize: '13px',
                                fontWeight: isSelected ? 700 : 400,
                                color: isSelected ? '#ED6628' : 'inherit',
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: 2,
                                py: 1,
                                px: 2,
                            }}
                        >
                            <span style={{ fontWeight: isSelected ? 700 : 500 }}>{name}</span>
                            <span style={{ fontSize: '11px', color: isSelected ? '#ED6628' : '#9ca3af', fontWeight: 600 }}>{code}</span>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default LanguageSelector;
